import { useMemo } from 'react';
import type { PageAssignment } from '../../api/endpoints';

interface SelectAllCompletedButtonProps {
  sectionAssignments: PageAssignment[];
  selectedIds: Set<number>;
  // Apply the button's decision: add (shouldSelect) or remove these ids from
  // the selection. The button is the single source of the select/deselect call.
  onToggle: (completedIds: number[], shouldSelect: boolean) => void;
}

// Selects (or deselects) every completed assignment in one upload group
export const SelectAllCompletedButton = ({
  sectionAssignments,
  selectedIds,
  onToggle,
}: SelectAllCompletedButtonProps) => {
  const completedIds = useMemo(
    () => sectionAssignments.filter((assignment) => assignment.status === 'completed').map((assignment) => assignment.id),
    [sectionAssignments],
  );
  const allSelected = useMemo(
    () => completedIds.length > 0 && completedIds.every((id) => selectedIds.has(id)),
    [completedIds, selectedIds],
  );
  
  return (
    <button
      className="btn-review-action btn-select-all"
      disabled={completedIds.length === 0}
      onClick={() => onToggle(completedIds, !allSelected)}
      title="Select all completed assignments in this upload (for a scoped Syntax Check)"
    >
      {allSelected ? 'Deselect All' : `Select All Completed (${completedIds.length})`}
    </button>
  );
};
